import { render, staticRenderFns } from "./lamsRegLegalLigationInfoTrack.vue?vue&type=template&id=5449c3d9&scoped=true&"
import script from "./lamsRegLegalLigationInfoTrack.vue?vue&type=script&lang=js&"
export * from "./lamsRegLegalLigationInfoTrack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5449c3d9",
  null
  
)

export default component.exports